// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w8PqT10v{width:min(520px,50vw);min-height:400px;display:flex;flex-direction:column}.w8PqT10v p{margin:0}.uuRktqFt{margin:auto;align-self:center;justify-self:center}`, "",{"version":3,"sources":["webpack://./src/page-components/modals/modals.module.scss"],"names":[],"mappings":"AAAA,UACE,qBAAA,CACA,gBAAA,CACA,YAAA,CACA,qBAAA,CAEA,YACE,QAAA,CAGJ,UACE,WAAA,CACA,iBAAA,CACA,mBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `w8PqT10v`,
	"loadingSpinner": `uuRktqFt`
};
export default ___CSS_LOADER_EXPORT___;
